export default __webpack_public_path__ + "static/media/ReportingIcon.8a04c8ab.svg";